// Browser storage used to be keyed woza_* and woza.*. Imported first in index.js so
// it runs before anything reads storage: each value moves to its wasaa name once, so
// nobody is signed out or loses a draft.
try {
  [window.localStorage, window.sessionStorage].forEach((store) => {
    const old = [];
    for (let i = 0; i < store.length; i += 1) {
      const key = store.key(i);
      if (key && (key.startsWith("woza_") || key.startsWith("woza."))) old.push(key);
    }
    old.forEach((key) => {
      const next = `wasaa${key.slice(4)}`;
      if (store.getItem(next) === null) store.setItem(next, store.getItem(key));
      store.removeItem(key);
    });
  });
} catch {
  // storage blocked: nothing to carry over
}
